export const DocumentOutline = (props) => (
  <svg
    style={{ ...props?.style }}
    width='12'
    height='14'
    viewBox='0 0 12 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.58594 1L11 4.41406V13H1V1H7.58594Z'
      stroke='#94A3B8'
      strokeWidth='2'
      strokeMiterlimit='10'
    />
    <path d='M3 10H9' stroke='#94A3B8' strokeWidth='2' strokeMiterlimit='10' />
    <path d='M3 7H9' stroke='#94A3B8' strokeWidth='2' strokeMiterlimit='10' />
    <path d='M3 4H6' stroke='#94A3B8' strokeWidth='2' strokeMiterlimit='10' />
  </svg>
);
